import { Component } from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import LastActionsStatPanel from './components/PanelLastActionsStat';
import PanelUserNotifications from './components/PanelUserNotifications';
import PushAlert from 'modules/notifications/push/PushAlert';
import Can from '../permissions/abilities/Can';

import './dashboard.css';

class DashBoard extends Component {
  render() {
    return (
      <div>
        <Row>
          <Col md={ 6 }>
            <h4 style={ { display: 'inline' } }>Рабочий стол</h4>
          </Col>
        </Row>

        <br /><br />

        <Row>
          <Col lg={ 10 } md={ 9 } sm={ 9 }>
            <PushAlert />
          </Col>
        </Row>

        <Row className='row'>
          <Can do='available' on='show.last.event'>
            <Col lg={ 6 } md={ 9 } sm={ 9 }>
              <LastActionsStatPanel />
            </Col>
          </Can>
          <Can do='available' on='show.notifications'>
            <Col lg={ 6 } md={ 9 } sm={ 9 }>
              <PanelUserNotifications />
            </Col>
          </Can>
        </Row>
      </div>
    );
  }
}

export default DashBoard;
